
import {
  popularServices,
  questions,
  serviceFeatures,
  cdnCoverage,
  wafItems,
  securityItems,
} from "~/data/soc";

import Modal from "~/components/rebranding/modal/Modal.vue";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      activeSection: "",
      FormTitle: "",
      serviceFeatures,
      cdnCoverage,
      wafItems,
      securityItems,
      popularServices,
      questions,
    };
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "SOC آبالون | از تحلیل تا پیشگیری تهدیدات سایبری",
      meta: [
        {
          name: "description",
          content:
            "راهکار SOC آبالون | پایش ترافیک سازمانی با ابزارهای پیشرفته | تحلیل و پیشگیری رخداد‌های امنیتی | SIEM ،XDR ،IDS ،DLP |‌ تیم مرکز عملیات امنیت آبالون",
        },
        {
          name: "keywords",
          content: "راهکار SOC,مرکز عملیات امنیت,تیم SOC",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/soc",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "SOC آبالون | از تحلیل تا پیشگیری تهدیدات سایبری",
        },
        {
          property: "og:description",
          content:
            "راهکار SOC آبالون | پایش ترافیک سازمانی با ابزارهای پیشرفته | تحلیل و پیشگیری رخداد‌های امنیتی | SIEM ،XDR ،IDS ،DLP |‌ تیم مرکز عملیات امنیت آبالون",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/soc",
        },
        {
          name: "twitter:title",
          title: "SOC آبالون | از تحلیل تا پیشگیری تهدیدات سایبری",
        },
        {
          name: "twitter:description",
          content:
            "راهکار SOC آبالون | پایش ترافیک سازمانی با ابزارهای پیشرفته | تحلیل و پیشگیری رخداد‌های امنیتی | SIEM ،XDR ،IDS ،DLP |‌ تیم مرکز عملیات امنیت آبالون",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/soc",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "راهکار SOC آبالون چیست؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "راهکار SOC آبالون مجموعه‌ای از ابزارهای امنیتی پیشرفته شامل SIEM، XDR، IDS/IPS، DLP و سیستم‌های تحلیل رفتار کاربران (UBA/UBEA) است که می‌تواند به‌صورت مستقل روی زیرساخت داخلی سازمان یا در دیتاسنترهای آبالون مستقر شود. با بهره‌گیری از فرآیندهای چندمرحله‌ای، این راهکار نظارت، تحلیل و واکنش به تهدیدات امنیتی را به‌صورت متمرکز و جامع فراهم می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان خرید و استقرار ابزارهای SOC به‌صورت مستقل از خدمات مدیریت‌شده وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، سازمان‌ها می‌توانند ابزارهای بومی SOC مانند SIEM، XDR و IDS یا IPS را به‌صورت مستقل تهیه و روی زیرساخت داخلی یا دیتاسنترهای آبالون پیاده‌سازی کنند. در این حالت، مدیریت عملیات امنیت بر عهده تیم فنی داخلی سازمان خواهد بود.",
                },
              },
              {
                "@type": "Question",
                name: "خدمات SOC مدیریت‌شده آبالون شامل چه مواردی است؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "در مدل مدیریت‌شده، تیم SOC آبالون مسئولیت پایش مداوم، تحلیل تهدیدات، واکنش به رخدادها، تهیه گزارش‌های تحلیلی و به‌روزرسانی فرآیندهای امنیتی را بر عهده دارد. این خدمات به‌صورت ۲۴ ساعته از طریق مرکز عملیات امنیت آبالون ارائه می‌شود.",
                },
              },
              {
                "@type": "Question",
                name: "راهکار SOC آبالون چگونه تهدیدات پیچیده و ناشناخته را شناسایی می‌کند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "راهکار SOC آبالون با ترکیب تحلیل داده‌های SIEM و XDR، پایش لحظه‌ای شبکه و نقاط پایانی، تحلیل رفتار کاربران (UBA/UBEA) و استفاده از پایگاه داده تهدیدات به‌روز، می‌تواند الگوهای غیرعادی و تهدیدات چندمرحله‌ای را شناسایی کرده و به‌صورت سریع و متمرکز واکنش نشان دهد. این رویکرد جامع، امکان مقابله با تهدیدات پیشرفته و ناشناخته را برای سازمان فراهم می‌کند.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "SOC آبالون | از تحلیل تا پیشگیری تهدیدات سایبری",
            },
            author: {
              "@type": "Person",
              name: "Hamid Karimi",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
